function heroDot(exceptions) {
  const heroDot = document.querySelector('.c-oval--hero')
  const heroSection = document.querySelector('section.hero')
  if (heroDot && heroSection) {
    if (exceptions.some(element => element == true)) {
      const heroBlock = document.querySelector('.js-hero')
      const heroheight = heroBlock.getBoundingClientRect().height
      heroDot.setAttribute('style', `top: ${heroheight}px;`)
      setTimeout(() => {
        heroDot.classList.remove('c-oval--hidden')
      }, 100)
    } else {
      const heroheight = heroSection.getBoundingClientRect().height
      heroDot.setAttribute('style', `top: ${heroheight}px;`)
      setTimeout(() => {
        heroDot.classList.remove('c-oval--hidden')
      }, 100)
    }
  }
}

export default heroDot
